/************
 Swipers
 ************/

// thumbnails mobile
let productV6ThumbnailImages = new Swiper("#productV6ThumbnailsSwiper", {
    slidesPerView: "auto",
    spaceBetween: 5,
    breakpoints: {
        800: {
            slidesPerView: 6,
        }
    },
    loop: true,
    navigation: {
        nextEl: '#productV6ThumbnailsNext',
        prevEl: '#productV6ThumbnailsPrev',
    },
});

// main swiper
let productV6Images = new Swiper("#productV6Swiper", {
    navigation: {
        nextEl: '#productV6Swiper .swiper-button-next',
        prevEl: '#productV6Swiper .swiper-button-prev',
    },
    loop: true,
    thumbs: {
        swiper: productV6ThumbnailImages
    }
});

// gallery desktop
document.querySelectorAll(".productV6GalleryItem").forEach(function (element) {
    element.addEventListener("click", function () {
        // determine index
        let index = getElIndex(this);

        // change active slide
        productV6Images.slideTo(index);
    });
});

/********************
 Video Popup
 *******************/

// open video
document.querySelector("#productV6FormGroupHeaderVideo")?.addEventListener("click", function (e) {
    e.preventDefault();
    const popup = document.querySelector(".videoPopup");
    popup.showModal();
    popup.querySelector("video").play();
});

/*****************
 Reviews
 ****************/

document.querySelector("#productV6Review")?.addEventListener("click", function () {
    window.scrollTo({
        top: document.querySelector("#looxReviews").offsetTop - 100,
        behavior: "smooth"
    });
})


/**************
 Function To Update Pricing
 ***************/

// update active variant
function updateProductV6() {
    // There are 3 senarios to determine the active variant
    // 1. Has only a default variant
    // 2. the color/background swatch
    // 3. the basic dropdown

    // check for an active color swatch
    if (product.variants.length === 1) {
        activeVariant = product.variants[0];
    } else if (document.querySelector(".productV6FormGroup.active")) {
        activeVariant = product.variants.filter((variant) => {
            return variant.id === parseInt(document.querySelector(".productV6FormGroupFlexColor:checked").value)
        })[0];
    } else {
        activeVariant = product.variants.filter((variant) => {
            return variant.id === parseInt(document.querySelector("#productV6FormVariants").value)
        })[0];
    }

    // find variant image
    if (activeVariant.featured_image) {
        const variantImage = document.querySelector(`.productV6SwiperSlide[id="${activeVariant.featured_image.id}"]`);
        if (variantImage) {
            productV6Images.slideTo(getElIndex(variantImage));
        }
    }

    // in the variant available?
    let isAvailable = activeVariant.available;

    // default quantity and discount
    let quantity = 1;
    let discount = 0;

    // update pricing (check for bundle discount)
    if (document.querySelector("#productV6Bundle")) {
        // parse discount from the selected bundle
        quantity = parseInt(document.querySelector(".productV6BundleOptionsItemInput:checked").value);
        discount = parseInt(document.querySelector(".productV6BundleOptionsItemInput:checked").getAttribute("data-discount"));

        // check if any of the selected items are out of stock
        document.querySelectorAll(`.productV6FormGroup.active .productV6FormGroupFlexColor:checked`).forEach(function (element) {
            if (element.dataset.available === "false") {
                isAvailable = false;
            }
        });
    }

    // compute price and compare at price
    let total = activeVariant.price * quantity - discount;
    let compareAtTotal = activeVariant.compare_at_price * quantity;

    // check for addon
    const hasAddon = document.querySelector("#productV6AddonCheckboxInput:checked")
    if (hasAddon) {
        total += parseInt(document.querySelector(".productV6AddonFormVariantsItem:checked").dataset.price);
        compareAtTotal += parseInt(document.querySelector(".productV6AddonFormVariantsItem:checked").dataset.compare);
    }

    // calculate savings
    let savings = compareAtTotal - total;
    let savingsPercent = Math.round((savings / compareAtTotal) * 100);

    // update display
    if (total < compareAtTotal) {
        const prefix = hasAddon ? "BUNDLE" : "";
        document.querySelector("#productV6PriceCompare").textContent = price(compareAtTotal, true);
        document.querySelector("#productV6PriceActual").textContent = `${prefix} ${price(total, true)}`;
        document.querySelector("#productV6PriceSavings").textContent = `SAVE ${savingsPercent}%`;
        document.querySelector("#productV6PriceSavings").classList.add('active');

    } else {
        document.querySelector("#productV6PriceCompare").textContent = "";
        document.querySelector("#productV6PriceActual").textContent = price(total, true);
        document.querySelector("#productV6PriceSavings").classList.remove('active');
    }


    // check if the variant is in stock
    if (isAvailable) {
        document.querySelector("#productV6ATC").classList.remove("oos");
        document.querySelector("#productV6ATC").textContent = `Add To Cart`;
    } else {
        document.querySelector("#productV6ATC").classList.add("oos");
        document.querySelector("#productV6ATC").textContent = "Sold Out — Notify Me When Available";
    }

    // update BOGO box prices
    let BOGOExists = document.querySelector('.productV6BOGO') || false;
    if (BOGOExists) {
        document.querySelector('.productV6BOGOPriceReal').textContent = price(activeVariant.price, true);
        document.querySelector('.productV6BOGOPriceCompare').textContent = "";
        if (activeVariant.compare_at_price > activeVariant.price) {
            document.querySelector('.productV6BOGOPriceCompare').textContent = price(activeVariant.compare_at_price, true);
        }
    }
}

/*******************
 Product Form (Default and Group)
 ********************/

// color swatch support on change
document.querySelectorAll(".productV6FormGroupFlexColor").forEach(function (element) {
    element.addEventListener("change", function () {
        // update label
        this.parentElement.parentElement.querySelector(".productV6FormGroupHeaderLabel").innerHTML = this.getAttribute("aria-label");

        // update price
        updateProductV6();
    });
});

// variant dropdown support on change
document.querySelector("#productV6FormVariants")?.addEventListener("change", updateProductV6);

/***********************
 Product Bundle (Vibit Roll)
 *********************/

/*
Bundle is only shown on the vibit roll page
Bundle allows the user to change how many form groups are shown
 */

if (document.querySelector("#productV6Bundle")) {
    // on input change
    document.querySelectorAll(`.productV6BundleOptionsItemInput`).forEach(function (element) {
        element.addEventListener("change", function () {
            // get index to know how many groups to show in the productV6 form
            let index = parseInt(this.value);

            // hide all productV6 form groups
            document.querySelectorAll(".productV6FormGroup").forEach(function (element) {
                element.classList.remove("active");
            });

            // show the correct number of productV6 form groups
            for (let i = 0; i < index; i++) {
                document.querySelectorAll(".productV6FormGroup")[i].classList.add("active");
            }

            // update price
            updateProductV6();
        });
    });
}

// if url has bundle, preselect it
if (urlParams.has("bundle")) {
    document.querySelector(`.productV6BundleOptionsItemInput[value="${urlParams.get("bundle")}"]`)?.parentElement.click();
}

/****************
 *  Quantity
 *************/

let quantity = 1;

// minus
document.querySelector("#productV6QuantityMinus")?.addEventListener("click", function () {
    // must not be less than 1
    if (quantity === 1) {
        return;
    }

    // decrement by 1
    quantity--;
    document.querySelector("#productV6QuantityValue").textContent = quantity;
});

// plus
document.querySelector("#productV6QuantityPlus")?.addEventListener("click", function () {
    // increment by 1
    quantity++;
    document.querySelector("#productV6QuantityValue").textContent = quantity;
});


/***************
 Product Addon
 ****************/

// select addon
if (document.querySelector("#productV6Addon")) {
    // input change
    document.querySelector("#productV6AddonCheckboxInput").addEventListener("change", function () {
        // update product form
        updateProductV6();

        // on check
        if (this.checked) {
            // update active class on parent
            document.querySelector("#productV6Addon").classList.add("active");

            // uncheck bogo button
            document.querySelector('.productV6BOGO')?.classList.remove('active');

            quantity = 1;

            // hide note
            document.querySelector('#productV6Note')?.classList.remove('active');

            // switch slides
            productV6Images.slideTo(productV6Images.slides.length - 1);
        } else {
            // remove active class on parent
            document.querySelector("#productV6Addon").classList.remove("active");

            // check bogo button
            document.querySelector('.productV6BOGO')?.classList.add('active');
            productV6Images.slideTo(0);

            quantity = 2;

            // show note
            document.querySelector('#productV6Note')?.classList.add('active');

        }
    });

    // variant selection change
    document.querySelectorAll(".productV6AddonFormVariantsItem").forEach(function (element) {
        element.addEventListener("change", updateProductV6);
    });

    // if url has addon, preselect it
    if (urlParams.has("addon")) {
        document.querySelector("#productV6AddonCheckbox").click();
    }

    /***************
     BOGO Button
     ****************/
    // toggle between bogo and addon
    document.querySelector('.productV6BOGO')?.addEventListener('click', function () {
        if (this.classList.contains('active')) {
            this.classList.remove('active');
            document.querySelector("#productV6AddonCheckbox").click();

            quantity = 1;

            // hide note
            document.querySelector('#productV6Note').classList.remove('active');
        } else {
            this.classList.add('active');
            document.querySelector("#productV6AddonCheckbox").click();
            productV6Images.slideTo(0)

            quantity = 2;
            // show note
            document.querySelector('#productV6Note').classList.add('active');
        }

    });
}

/**************
 ORDERS REMAINING
 ***************/

// Consistent random number generation using the hash as a seed
function generateSeededRandom(key, min, max) {
    let hash = 0;
    for (let i = 0; i < key.length; i++) {
        hash = (hash << 5) - hash + key.charCodeAt(i);
        hash |= 0;
    }

    const x = Math.sin(hash) * 10000;
    const seed = x - Math.floor(x);

    return Math.floor(seed * (max - min + 1) + min);
}

let ordersRemaining = localStorage.getItem('ordersRemaining');

// check local storage for orders remaining and set
if (ordersRemaining && localStorage.getItem('productHandle') === product.handle) {
    document.querySelector('#productV6ShippingRemainingTxt').textContent = `${ordersRemaining} orders remaining`;
} else {
    // generate random number and set local storage if not found
    ordersRemaining = generateSeededRandom(product.handle, 10, 100);
    localStorage.setItem('ordersRemaining', ordersRemaining);
    localStorage.setItem('productHandle', product.handle);
    document.querySelector('#productV6ShippingRemainingTxt').textContent = `${ordersRemaining} orders remaining`;
}


/**************
 Product ATC
 ***************/

// add to cart button
document.querySelector("#productV6ATC").addEventListener("click", async function (e) {
    e.preventDefault();

    // check for out of stock
    if (this.classList.contains("oos")) {
        // check email
        let {value: email} = await Swal.fire({
            title: product.title,
            text: "Enter your email to be notified when this product is back in stock.",
            input: "email",
            inputPlaceholder: "Email Address",
            confirmButtonText: "Notify Me When Available",
        });

        // confirm email is returned
        if (!email) {
            return;
        }

        // add to waitlist
        let formData = new FormData();
        formData.append("a", await klaviyo.account());
        formData.append("email", email);
        formData.append("g", "");
        formData.append("variant", activeVariant.id);
        formData.append("product", product.id);
        formData.append("platform", "shopify");
        formData.append("subscribe_for_newsletter", false);
        fetch("https://a.klaviyo.com/onsite/components/back-in-stock/subscribe", {
            method: "POST",
            body: formData
        })

        // show success message
        await Swal.fire({
            title: "Success!",
            text: "You will be notified when this product is back in stock.",
            confirmButtonText: "OK",
        });

        return;
    }

    // add loading animation
    this.classList.add("loading");

    // determine which time of productV6 we're adding to cart
    // 1. Bundle
    // 2. Single Product

    // create form data
    let formData = {
        items: []
    };

    // check for BOGO (default to 2 quantity)
    if (document.querySelector('.productV6BOGO')?.classList.contains('active')) {
        quantity = 2;
    }

    // check for bundle
    if (document.querySelector("#productV6Bundle") && !document.querySelector('.productV6BOGO')?.classList.contains('active')) {
        // add each item to the form data
        document.querySelectorAll(".productV6FormGroup.active .productV6FormGroupFlexColor:checked").forEach(function (element) {
            formData.items.push({
                quantity: 1,
                id: parseInt(element.value),
                // important note here, since somebody can select 3 of the same color, we need to add a unique source for each item
                properties: {
                    "__source": element.getAttribute("name")
                }
            });
        });
    }
    // normal product
    else {
        formData.items.push({
            quantity: quantity,
            id: activeVariant.id,
        });
    }

    // check if addon
    const hasAddon = !!document.querySelector("#productV6AddonCheckboxInput:checked");
    if (hasAddon) {
        formData.items.push({
            quantity: 1,
            id: parseInt(document.querySelector(".productV6AddonFormVariantsItem:checked").value),
        });
    }

    // check if vibit roll, add tutorial video
    if (product.handle === "the-vibit" || hasAddon) {
        formData.items.push({
            quantity: 1,
            id: tutorial.variants[0].id,
        });
    }

    // check for neck stretch
    if (Shopify.shop === "vibit-com-au.myshopify.com" && product.handle === "neck-stretch") {
        formData.items.push({
            quantity: 1,
            id: neckStretchEbook.variants[0].id,
        })
    }

    // add productV6
    await addProduct(formData);

    // klaviyo tracking
    try {
        _learnq.push(['track', 'Added to Cart', item]);
    } catch (error) {
        console.error("Klaviyo tracking not found");
    }

    // remove loading animation
    this.classList.remove("loading");

    // open cart
    await openCart();
});


// atc call to action
document.querySelectorAll(`.button[href="#add_to_cart"]`).forEach(function (element) {
    element.addEventListener("click", async function (e) {
        e.preventDefault();

        // click normal atc
        document.querySelector("#productV6ATC").click();

        // start/stop loading
        this.classList.add("loading");
        await sleep(1000);
        this.classList.remove("loading");
    });
});

// atc call to action
document.querySelectorAll(`.button[href="#add_to_cart_addon"]`).forEach(function (element) {
    element.addEventListener("click", async function (e) {
        e.preventDefault();

        // check the addon if not already checked
        if (!document.querySelector("#productV6AddonCheckboxInput").checked) {
            document.querySelector("#productV6AddonCheckbox").click();
        }


        // click normal atc
        document.querySelector("#productV6ATC").click();

        // start/stop loading
        this.classList.add("loading");
        await sleep(1000);
        this.classList.remove("loading");
    });
});


/**************
 Shipping Time
 ***************/

// show shipping tomorrow
let date = new Date();
date.setDate(date.getDate() + 1);
date = date.toLocaleDateString('en-US', {month: 'short', day: 'numeric'});
document.querySelector('#productV6ShippingDateTxt').innerHTML = `Ships <strong>Tomorrow, ${date}</strong>`;


/**************
 Sticky ATC
 ***************/

const stickyAtcObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
        if (entry.isIntersecting) {
            document.querySelector("#productV6ATC").classList.remove("sticky");
        } else {
            document.querySelector("#productV6ATC").classList.add("sticky");
        }
    });
}, {
    rootMargin: "-100px 0px 0px 0px"
})

stickyAtcObserver.observe(document.querySelector("#productV6Content"));

// event listeners for dropdown items
document.querySelectorAll(`.productV6DropdownTop`).forEach(function (element) {
    element.addEventListener("click", function () {
        this.parentElement.classList.toggle("active");
    });
});

